import { FCX } from "@datassential/platform-ui-lib";
import Stars from "@components/Stars/Stars";

function renderMetricValue(value: number) {
    if (!Math.round(value)) return '-';
    return `${Math.round(value)}%`;
}

export const StarsCell: FCX<{
    value: number;
    starsCount: number;
}> = ({
    value,
    starsCount,
}) => {
    return (
        <div className="StarCell">
            {renderMetricValue(value)}
            <Stars count={starsCount}/>
        </div>
    );
}